"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanningItemApi = exports.PlanningItemApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
// @ts-ignore
const models_3 = require("../models");
// @ts-ignore
const models_4 = require("../models");
// @ts-ignore
const models_5 = require("../models");
// @ts-ignore
const models_6 = require("../models");
// @ts-ignore
const models_7 = require("../models");
/**
 * PlanningItemApi - axios parameter creator
 * @export
 */
const PlanningItemApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {RequestPlanningItemApproveLeadQuoteBody} requestPlanningItemApproveLeadQuoteBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePlanningItemLeadQuote: async (requestPlanningItemApproveLeadQuoteBody, options = {}) => {
            // verify required parameter 'requestPlanningItemApproveLeadQuoteBody' is not null or undefined
            (0, common_1.assertParamExists)('approvePlanningItemLeadQuote', 'requestPlanningItemApproveLeadQuoteBody', requestPlanningItemApproveLeadQuoteBody);
            const localVarPath = `/api/planning-item/approve-lead-quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemApproveLeadQuoteBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMaintenancePlanningItem: async (planningItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('cancelMaintenancePlanningItem', 'planningItemId', planningItemId);
            const localVarPath = `/api/planning-item/maintenance/{planning_item_id}/cancel`
                .replace(`{${"planning_item_id"}}`, encodeURIComponent(String(planningItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {PlanningItemDeliveryAddressChange} planningItemDeliveryAddressChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePlanningItemDeliveryAddress: async (planningItemId, planningItemDeliveryAddressChange, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('changePlanningItemDeliveryAddress', 'planningItemId', planningItemId);
            // verify required parameter 'planningItemDeliveryAddressChange' is not null or undefined
            (0, common_1.assertParamExists)('changePlanningItemDeliveryAddress', 'planningItemDeliveryAddressChange', planningItemDeliveryAddressChange);
            const localVarPath = `/api/planning-item/change-delivery-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planning_item_id'] = planningItemId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(planningItemDeliveryAddressChange, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RequestPlanningItemCreateBody} requestPlanningItemCreateBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanningItem: async (requestPlanningItemCreateBody, options = {}) => {
            // verify required parameter 'requestPlanningItemCreateBody' is not null or undefined
            (0, common_1.assertParamExists)('createPlanningItem', 'requestPlanningItemCreateBody', requestPlanningItemCreateBody);
            const localVarPath = `/api/planning-item/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemCreateBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemAttachmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanningItemAttachment: async (planningItemAttachmentId, options = {}) => {
            // verify required parameter 'planningItemAttachmentId' is not null or undefined
            (0, common_1.assertParamExists)('deletePlanningItemAttachment', 'planningItemAttachmentId', planningItemAttachmentId);
            const localVarPath = `/api/planning-item/attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemAttachmentId !== undefined) {
                localVarQueryParameter['planning_item_attachment_id'] = planningItemAttachmentId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanningItemsExcel: async (inlineObject1, options = {}) => {
            // verify required parameter 'inlineObject1' is not null or undefined
            (0, common_1.assertParamExists)('downloadPlanningItemsExcel', 'inlineObject1', inlineObject1);
            const localVarPath = `/api/planning-item/list/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RequestPlanningItemFinishManualBody} requestPlanningItemFinishManualBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishManualPlanningItem: async (requestPlanningItemFinishManualBody, options = {}) => {
            // verify required parameter 'requestPlanningItemFinishManualBody' is not null or undefined
            (0, common_1.assertParamExists)('finishManualPlanningItem', 'requestPlanningItemFinishManualBody', requestPlanningItemFinishManualBody);
            const localVarPath = `/api/planning-item/finish-manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemFinishManualBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RequestPlanningItemFinishBody} requestPlanningItemFinishBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishPlanningItem: async (requestPlanningItemFinishBody, options = {}) => {
            // verify required parameter 'requestPlanningItemFinishBody' is not null or undefined
            (0, common_1.assertParamExists)('finishPlanningItem', 'requestPlanningItemFinishBody', requestPlanningItemFinishBody);
            const localVarPath = `/api/planning-item/finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemFinishBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFeedback: async (planningItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('getLeadFeedback', 'planningItemId', planningItemId);
            const localVarPath = `/api/planning-item/{planning_item_id}/lead-feedback`
                .replace(`{${"planning_item_id"}}`, encodeURIComponent(String(planningItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} fromSuggestedDate
         * @param {string} toSuggestedDate
         * @param {number} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadTypeFinancialStatistics: async (fromSuggestedDate, toSuggestedDate, userId, options = {}) => {
            // verify required parameter 'fromSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getLeadTypeFinancialStatistics', 'fromSuggestedDate', fromSuggestedDate);
            // verify required parameter 'toSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getLeadTypeFinancialStatistics', 'toSuggestedDate', toSuggestedDate);
            const localVarPath = `/api/planning-item/get-lead-type-financial-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (fromSuggestedDate !== undefined) {
                localVarQueryParameter['from_suggested_date'] = (fromSuggestedDate instanceof Date) ?
                    fromSuggestedDate.toISOString() :
                    fromSuggestedDate;
            }
            if (toSuggestedDate !== undefined) {
                localVarQueryParameter['to_suggested_date'] = (toSuggestedDate instanceof Date) ?
                    toSuggestedDate.toISOString() :
                    toSuggestedDate;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningItemClientHistory: async (clientId, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('getPlanningItemClientHistory', 'clientId', clientId);
            const localVarPath = `/api/planning-item/get-client-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [calendarItemId]
         * @param {number} [planningItemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningItemDetail: async (calendarItemId, planningItemId, options = {}) => {
            const localVarPath = `/api/planning-item/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (calendarItemId !== undefined) {
                localVarQueryParameter['calendar_item_id'] = calendarItemId;
            }
            if (planningItemId !== undefined) {
                localVarQueryParameter['planning_item_id'] = planningItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [includeInactive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningItemSubTypes: async (includeInactive, options = {}) => {
            const localVarPath = `/api/planning-item/sub-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {boolean} [inCalendarOfUser]
         * @param {boolean} [inCalendarOfUser2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanningItems: async (inlineObject, inCalendarOfUser, inCalendarOfUser2, options = {}) => {
            // verify required parameter 'inlineObject' is not null or undefined
            (0, common_1.assertParamExists)('listPlanningItems', 'inlineObject', inlineObject);
            const localVarPath = `/api/planning-item/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (inCalendarOfUser !== undefined) {
                localVarQueryParameter['in_calendar_of_user'] = inCalendarOfUser;
            }
            if (inCalendarOfUser2 !== undefined) {
                localVarQueryParameter['inCalendarOfUser'] = inCalendarOfUser2;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PlanningItemPlanBody} planningItemPlanBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        planPlanningItem: async (planningItemPlanBody, options = {}) => {
            // verify required parameter 'planningItemPlanBody' is not null or undefined
            (0, common_1.assertParamExists)('planPlanningItem', 'planningItemPlanBody', planningItemPlanBody);
            const localVarPath = `/api/planning-item/plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(planningItemPlanBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        protestLead: async (planningItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('protestLead', 'planningItemId', planningItemId);
            const localVarPath = `/api/planning-item/{planning_item_id}/protest`
                .replace(`{${"planning_item_id"}}`, encodeURIComponent(String(planningItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenLead: async (planningItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('reopenLead', 'planningItemId', planningItemId);
            const localVarPath = `/api/planning-item/{planning_item_id}/reopen`
                .replace(`{${"planning_item_id"}}`, encodeURIComponent(String(planningItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {RequestPlanningItemPlannedUsersBody} requestPlanningItemPlannedUsersBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPlannedUsers: async (planningItemId, requestPlanningItemPlannedUsersBody, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('setPlannedUsers', 'planningItemId', planningItemId);
            // verify required parameter 'requestPlanningItemPlannedUsersBody' is not null or undefined
            (0, common_1.assertParamExists)('setPlannedUsers', 'requestPlanningItemPlannedUsersBody', requestPlanningItemPlannedUsersBody);
            const localVarPath = `/api/planning-item/{planning_item_id}/planned-users`
                .replace(`{${"planning_item_id"}}`, encodeURIComponent(String(planningItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemPlannedUsersBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RequestPlanningItemUpdateBody} requestPlanningItemUpdateBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningItem: async (requestPlanningItemUpdateBody, options = {}) => {
            // verify required parameter 'requestPlanningItemUpdateBody' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItem', 'requestPlanningItemUpdateBody', requestPlanningItemUpdateBody);
            const localVarPath = `/api/planning-item/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPlanningItemUpdateBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {RequestUpdatePlanningItemDataBody} requestUpdatePlanningItemDataBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningItemData: async (planningItemId, requestUpdatePlanningItemDataBody, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemData', 'planningItemId', planningItemId);
            // verify required parameter 'requestUpdatePlanningItemDataBody' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemData', 'requestUpdatePlanningItemDataBody', requestUpdatePlanningItemDataBody);
            const localVarPath = `/api/planning-item/update/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planningItemId'] = planningItemId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestUpdatePlanningItemDataBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {string} description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningItemDescription: async (planningItemId, description, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemDescription', 'planningItemId', planningItemId);
            // verify required parameter 'description' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemDescription', 'description', description);
            const localVarPath = `/api/planning-item/update-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planning_item_id'] = planningItemId;
            }
            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {number} waterMeterStand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningItemWaterMeterStand: async (planningItemId, waterMeterStand, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemWaterMeterStand', 'planningItemId', planningItemId);
            // verify required parameter 'waterMeterStand' is not null or undefined
            (0, common_1.assertParamExists)('updatePlanningItemWaterMeterStand', 'waterMeterStand', waterMeterStand);
            const localVarPath = `/api/planning-item/update-water-meter-stand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planning_item_id'] = planningItemId;
            }
            if (waterMeterStand !== undefined) {
                localVarQueryParameter['water_meter_stand'] = waterMeterStand;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {number} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserToPlanningItem: async (planningItemId, userId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('updateUserToPlanningItem', 'planningItemId', planningItemId);
            const localVarPath = `/api/planning-item/assign-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planning_item_id'] = planningItemId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {any} fileToUpload
         * @param {number} [calendarItemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPlanningItemAttachment: async (planningItemId, fileToUpload, calendarItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('uploadPlanningItemAttachment', 'planningItemId', planningItemId);
            // verify required parameter 'fileToUpload' is not null or undefined
            (0, common_1.assertParamExists)('uploadPlanningItemAttachment', 'fileToUpload', fileToUpload);
            const localVarPath = `/api/planning-item/attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planning_item_id'] = planningItemId;
            }
            if (calendarItemId !== undefined) {
                localVarQueryParameter['calendar_item_id'] = calendarItemId;
            }
            if (fileToUpload !== undefined) {
                localVarFormParams.append('file_to_upload', fileToUpload);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PlanningItemApiAxiosParamCreator = PlanningItemApiAxiosParamCreator;
/**
 * PlanningItemApi -
 */
var PlanningItemApi;
(function (PlanningItemApi) {
    /**
     *
     * @param {RequestPlanningItemApproveLeadQuoteBody} requestPlanningItemApproveLeadQuoteBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/approve-lead-quote
     */
    async function approvePlanningItemLeadQuote(requestPlanningItemApproveLeadQuoteBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.approvePlanningItemLeadQuote(requestPlanningItemApproveLeadQuoteBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.approvePlanningItemLeadQuote = approvePlanningItemLeadQuote;
    /**
     *
     * @param {number} planningItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/maintenance/{planning_item_id}/cancel
     */
    async function cancelMaintenancePlanningItem(planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMaintenancePlanningItem(planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.cancelMaintenancePlanningItem = cancelMaintenancePlanningItem;
    /**
     *
     * @param {number} planningItemId
     * @param {PlanningItemDeliveryAddressChange} planningItemDeliveryAddressChange
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/change-delivery-address
     */
    async function changePlanningItemDeliveryAddress(planningItemId, planningItemDeliveryAddressChange, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.changePlanningItemDeliveryAddress(planningItemId, planningItemDeliveryAddressChange, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_7.parsePlanningItemDeliveryAddressChangeResult)(res.data);
            return res;
        });
    }
    PlanningItemApi.changePlanningItemDeliveryAddress = changePlanningItemDeliveryAddress;
    /**
     *
     * @param {RequestPlanningItemCreateBody} requestPlanningItemCreateBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/create
     */
    async function createPlanningItem(requestPlanningItemCreateBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanningItem(requestPlanningItemCreateBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.createPlanningItem = createPlanningItem;
    /**
     *
     * @param {number} planningItemAttachmentId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/attachment
     */
    async function deletePlanningItemAttachment(planningItemAttachmentId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanningItemAttachment(planningItemAttachmentId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.deletePlanningItemAttachment = deletePlanningItemAttachment;
    /**
     *
     * @param {InlineObject1} inlineObject1
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/list/excel
     */
    async function downloadPlanningItemsExcel(inlineObject1, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPlanningItemsExcel(inlineObject1, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.downloadPlanningItemsExcel = downloadPlanningItemsExcel;
    /**
     *
     * @param {RequestPlanningItemFinishManualBody} requestPlanningItemFinishManualBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/finish-manual
     */
    async function finishManualPlanningItem(requestPlanningItemFinishManualBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.finishManualPlanningItem(requestPlanningItemFinishManualBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.finishManualPlanningItem = finishManualPlanningItem;
    /**
     *
     * @param {RequestPlanningItemFinishBody} requestPlanningItemFinishBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/finish
     */
    async function finishPlanningItem(requestPlanningItemFinishBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.finishPlanningItem(requestPlanningItemFinishBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.finishPlanningItem = finishPlanningItem;
    /**
     *
     * @param {number} planningItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/{planning_item_id}/lead-feedback
     */
    async function getLeadFeedback(planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadFeedback(planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseILeadFeedbackEntity)(x));
            return res;
        });
    }
    PlanningItemApi.getLeadFeedback = getLeadFeedback;
    /**
     *
     * @param {string} fromSuggestedDate
     * @param {string} toSuggestedDate
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/get-lead-type-financial-statistics
     */
    async function getLeadTypeFinancialStatistics(fromSuggestedDate, toSuggestedDate, userId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadTypeFinancialStatistics(fromSuggestedDate, toSuggestedDate, userId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_2.parseILeadTypeReportEntity)(x));
            return res;
        });
    }
    PlanningItemApi.getLeadTypeFinancialStatistics = getLeadTypeFinancialStatistics;
    /**
     *
     * @param {number} clientId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/get-client-history
     */
    async function getPlanningItemClientHistory(clientId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanningItemClientHistory(clientId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_4.parseIPlanningItemEntity)(x));
            return res;
        });
    }
    PlanningItemApi.getPlanningItemClientHistory = getPlanningItemClientHistory;
    /**
     *
     * @param {number} [calendarItemId]
     * @param {number} [planningItemId]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/detail
     */
    async function getPlanningItemDetail(calendarItemId, planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanningItemDetail(calendarItemId, planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.getPlanningItemDetail = getPlanningItemDetail;
    /**
     *
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/sub-types
     */
    async function getPlanningItemSubTypes(includeInactive, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanningItemSubTypes(includeInactive, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_5.parseIPlanningItemSubTypeEntity)(x));
            return res;
        });
    }
    PlanningItemApi.getPlanningItemSubTypes = getPlanningItemSubTypes;
    /**
     *
     * @param {InlineObject} inlineObject
     * @param {boolean} [inCalendarOfUser]
     * @param {boolean} [inCalendarOfUser2]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/list
     */
    async function listPlanningItems(inlineObject, inCalendarOfUser, inCalendarOfUser2, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanningItems(inlineObject, inCalendarOfUser, inCalendarOfUser2, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_6.parseInlineResponse200)(res.data);
            return res;
        });
    }
    PlanningItemApi.listPlanningItems = listPlanningItems;
    /**
     *
     * @param {PlanningItemPlanBody} planningItemPlanBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/plan
     */
    async function planPlanningItem(planningItemPlanBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.planPlanningItem(planningItemPlanBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.planPlanningItem = planPlanningItem;
    /**
     *
     * @param {number} planningItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/{planning_item_id}/protest
     */
    async function protestLead(planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.protestLead(planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.protestLead = protestLead;
    /**
     *
     * @param {number} planningItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/{planning_item_id}/reopen
     */
    async function reopenLead(planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.reopenLead(planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.reopenLead = reopenLead;
    /**
     *
     * @param {number} planningItemId
     * @param {RequestPlanningItemPlannedUsersBody} requestPlanningItemPlannedUsersBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/{planning_item_id}/planned-users
     */
    async function setPlannedUsers(planningItemId, requestPlanningItemPlannedUsersBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.setPlannedUsers(planningItemId, requestPlanningItemPlannedUsersBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    PlanningItemApi.setPlannedUsers = setPlannedUsers;
    /**
     *
     * @param {RequestPlanningItemUpdateBody} requestPlanningItemUpdateBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/update
     */
    async function updatePlanningItem(requestPlanningItemUpdateBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningItem(requestPlanningItemUpdateBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.updatePlanningItem = updatePlanningItem;
    /**
     *
     * @param {number} planningItemId
     * @param {RequestUpdatePlanningItemDataBody} requestUpdatePlanningItemDataBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/update/data
     */
    async function updatePlanningItemData(planningItemId, requestUpdatePlanningItemDataBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningItemData(planningItemId, requestUpdatePlanningItemDataBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.updatePlanningItemData = updatePlanningItemData;
    /**
     *
     * @param {number} planningItemId
     * @param {string} description
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/update-description
     */
    async function updatePlanningItemDescription(planningItemId, description, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningItemDescription(planningItemId, description, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.updatePlanningItemDescription = updatePlanningItemDescription;
    /**
     *
     * @param {number} planningItemId
     * @param {number} waterMeterStand
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/update-water-meter-stand
     */
    async function updatePlanningItemWaterMeterStand(planningItemId, waterMeterStand, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningItemWaterMeterStand(planningItemId, waterMeterStand, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.updatePlanningItemWaterMeterStand = updatePlanningItemWaterMeterStand;
    /**
     *
     * @param {number} planningItemId
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/assign-user
     */
    async function updateUserToPlanningItem(planningItemId, userId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserToPlanningItem(planningItemId, userId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_4.parseIPlanningItemEntity)(res.data);
            return res;
        });
    }
    PlanningItemApi.updateUserToPlanningItem = updateUserToPlanningItem;
    /**
     *
     * @param {number} planningItemId
     * @param {any} fileToUpload
     * @param {number} [calendarItemId]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemApi
     * url /api/planning-item/attachment
     */
    async function uploadPlanningItemAttachment(planningItemId, fileToUpload, calendarItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPlanningItemAttachment(planningItemId, fileToUpload, calendarItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIPlanningItemAttachment)(res.data);
            return res;
        });
    }
    PlanningItemApi.uploadPlanningItemAttachment = uploadPlanningItemAttachment;
})(PlanningItemApi || (exports.PlanningItemApi = PlanningItemApi = {}));
